import styled from 'styled-components';
import { body2, colors, heading5, spacing } from 'ui/theme';
import { TextButton } from 'ui/button';

export const LaunchpadStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${spacing.base};  
`;

export const LaunchpadLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.double};
`;

export const LaunchpadStateTitle = styled.h5`
  ${heading5};
  margin: 0;
`;

export const LaunchpadStateDescription = styled.p`
  ${body2};
  color: ${colors.textSecondary};
  text-align: center;
`;

export const StyledTextButton = styled(TextButton)`
  padding: 0;
  display: inline;
`;
